import request from '@/utils/request'

export function getReceivers() {
  return request({
    url: 'ertebat/getreceivers',
    method: 'post'
  })
}

export function getReceiversV3() {
  return request({
    url: 'ertebat/getreceiversv3',
    method: 'post'
  })
}

export function getMessages() {
  return request({
    url: 'ertebat/getmessages',
    method: 'post'
  })
}

export function sendMessage(files, id, title, text) {
  var fmData = new FormData();
  fmData.append('reciverChartID', id)
  fmData.append('subject', title)
  fmData.append('message', text)
  if (files != null) {
    for (var i = 0; i < files.length; i++) {
      fmData.append("image" + i, files[i])
    }
  }
  return request({
    url: 'ertebat/sendmessage',
    method: 'post',
    data: fmData

  })
}

export function sendMessageV3(files, id, text) {
  var fmData = new FormData();
  fmData.append('Fserial', id)
  fmData.append('message', text)
  if (files != null) {
    for (var i = 0; i < files.length; i++) {
      fmData.append("image" + i, files[i])
    }
  }
  return request({
    url: 'ertebat/sendmessagev3',
    method: 'post',
    data: fmData

  })
}

export function downloadAttach(Fserial) {
  return request({
    url: '/ertebat/downloadattach',
    method: 'post',
    
    data: { Fserial: Fserial }
  })
}










